import useClientState from '@/state/useClientState';

//
const useVervangStamgegevens = () => {
  const vervangAlleDienstregelpunten = useClientState((state) => state.vervangAlleDienstregelpunten);
  const vervangAlleMaterieelTypen = useClientState((state) => state.vervangAlleMaterieelTypen);

  return { vervangAlleDienstregelpunten, vervangAlleMaterieelTypen };
};
export default useVervangStamgegevens;
